import useClientList from "../useClientList";
import { filtresClientsParDefaut } from "../clientFiltersDefault";
import { appliquerRegleSansFiche } from "./clientFilterRules";
import { emptyPatchFor, isPresetActive } from "./clientPresets";

// Logique de la cartouche de filtres clients, pendant de useLeadAutoFilters.
// L'état reste `{ user: {…}, page }`, le contrat de `customers/search`.
const useClientFilters = () => {
  const { clientFilters, isLoadingClients, isListInit, resultCount, actions: listActions } =
    useClientList();
  const filtres = clientFilters.user;

  // Nouvel état après un patch : page 1 et règle « sans fiche » appliquée.
  const avec = (patch) => ({
    ...clientFilters,
    page: 1,
    user: appliquerRegleSansFiche({ ...filtres, ...patch }),
  });

  // Modifie sans chercher (champ de recherche, tiroir) : la recherche part au submit.
  const updateFilters = (patch) => listActions.onClientFiltersChange(avec(patch));
  const updateFilter = (name, value) => updateFilters({ [name]: value });

  // Applique un patch et cherche tout de suite, avec la valeur calculée ici.
  const applyAndSearch = (patch) => {
    const next = avec(patch);
    listActions.onClientFiltersChange(next);
    listActions.onGetClients({ overrideFilters: next });
  };

  // Vues rapides : re-cliquer une vue active remet ses champs à leur défaut.
  const applyPreset = (preset, ctx) => {
    const patch = preset.build(ctx);
    applyAndSearch(isPresetActive(preset, filtres, ctx) ? emptyPatchFor(patch) : patch);
  };

  const isPresetOn = (preset, ctx) => isPresetActive(preset, filtres, ctx);

  const removeFilterToken = (clearPatch) => applyAndSearch(clearPatch);

  const clearAllFilters = () => {
    const fresh = filtresClientsParDefaut();
    listActions.onClientFiltersChange(fresh);
    listActions.onGetClients({ overrideFilters: fresh });
  };

  return {
    filtres,
    clientFilters,
    isLoadingClients,
    isListInit,
    resultCount,
    actions: {
      updateFilter,
      updateFilters,
      applyAndSearch,
      applyPreset,
      isPresetOn,
      removeFilterToken,
      clearAllFilters,
    },
  };
};

export default useClientFilters;
